module.exports = __webpack_public_path__ + "static/prepared_agent-c847f7032e83e89613b4737a81e58bb3.svg";